import React, { FC } from 'react';
import { createUseStyles } from 'src/theming';
import { NavLink } from 'react-router-dom';

const useStyles = createUseStyles({
  root: {
    margin: '0px 0px 4px',
    cursor: 'pointer',
    verticalAlign: 'middle',
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-start',
    alignItems: 'center',
    textAlign: 'left',
    padding: '8px 0 8px 0',
    position: 'relative',
    textTransform: 'capitalize',
    color: 'rgb(99, 115, 129) !important',
    fontWeight: 400,
    borderRadius: 8,
    wordBreak: 'break-word',
    '&$active': {
      color: 'rgb(33, 43, 54) !important',
      fontWeight: 500,
    },
    '&$active > $icon > span': {
      backgroundColor: 'rgb(0, 171, 85) !important',
      transform: 'scale(2)',
    },
  },
  icon: {
    flexShrink: 0,
    marginRight: 6,
    width: 22,
    height: 22,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > span': {
      width: 4,
      height: 4,
      borderRadius: '50%',
      backgroundColor: 'rgb(145, 158, 171)',
      transition: 'transform 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },
  },
  active: {},
  text: {},
});

interface Props {
  link: string;
  label: string;
  active?: boolean;
}

const ListItem: FC<Props> = ({ link, label, active }) => {
  const classes = useStyles({ active });

  return (
    <NavLink exact activeClassName={classes.active} className={classes.root} to={link}>
      <div className={classes.icon}>
        <span />
      </div>
      <div className={classes.text}>{label}</div>
    </NavLink>
  );
};

export default ListItem;
